export default __webpack_public_path__ + "static/media/sabFace.70b86798.webp";